import { noop } from "lodash";
import { t } from "@/i18n-js/instance";
import { DataTable } from "@circle-react-uikit/DataTableV2";
import { useBulkDeleteSnippetModal } from "./BulkDeleteSnippetModal";
import { usePreviewSnippetDrawer } from "./PreviewSnippetDrawer";
import { isSnippetTypeAFile } from "./utilities";

export const DropdownActions = ({ snippet }: { snippet: any }) => {
  const previewSnippetDrawer = usePreviewSnippetDrawer();
  const bulkDeleteSnippetModal = useBulkDeleteSnippetModal();

  // eslint-disable-next-line no-constant-binary-expression -- Updating typescript-eslint, should be fixed when appropriate
  const isFile = isSnippetTypeAFile(String(snippet?.type) ?? "");

  return (
    <DataTable.Actions>
      <DataTable.Actions.Item
        onClick={event => {
          event.stopPropagation();
          void previewSnippetDrawer.show({ snippetId: snippet.id });
        }}
      >
        {t("settings.community_bot.knowledge.custom.preview")}
      </DataTable.Actions.Item>
      {isFile && (
        <DataTable.Actions.Item
          onClick={event => {
            event.stopPropagation();
            window.open(snippet.file_url, "_blank");
          }}
        >
          {t("settings.community_bot.knowledge.custom.download")}
        </DataTable.Actions.Item>
      )}
      <DataTable.Actions.Item
        hasDanger
        onClick={event => {
          event.stopPropagation();
          void bulkDeleteSnippetModal.show({
            selectedIds: [snippet.id],
            setSelectedIds: noop,
          });
        }}
      >
        {t("settings.community_bot.knowledge.custom.delete")}
      </DataTable.Actions.Item>
    </DataTable.Actions>
  );
};
